import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { Popover } from 'components/popover';
import PropTypes from 'prop-types';

import './TooltipPortal.scss';

class TooltipPortal extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    parentId: PropTypes.string.isRequired,
    show: PropTypes.bool,
    arrowPos: PropTypes.string
  };

  static defaultProps = {
    arrowPos: 'center'
  };

  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.parent = null;
  }

  toggleShow = () => {
    const { show } = this.state;

    this.setState({ show: !show }, () => {
      if (this.state.show && this.props.onShow) {
        this.props.onShow();
      }
      if (!this.state.show && this.props.onHide) {
        this.props.onHide();
      }
    });
  };

  componentDidMount() {
    const { parentId } = this.props;

    this.parent = document.getElementById(parentId);
    const parent = this.parent;

    if (!parent) {
      return;
    }

    parent.setAttribute('data-tooltip', true);
    parent.addEventListener('mouseenter', this.toggleShow);
    parent.addEventListener('mouseleave', this.toggleShow);
  }

  componentWillUnmount() {
    const parent = this.parent;

    if (!parent) {
      return;
    }

    parent.removeEventListener('mouseenter', this.toggleShow);
    parent.removeEventListener('mouseleave', this.toggleShow);
  }

  render() {
    const { show } = this.state;
    const { arrowPos, className, ...props } = this.props;

    const tooltipClassName = classNames(
      'tooltip__portal',
      `tooltip__portal--${arrowPos}`,
      className
    );

    return (
      <Popover
        className={tooltipClassName}
        backdrop={false}
        show={show}
        {...props}
      >
        {this.props.children}
      </Popover>
    );
  }
}

export default TooltipPortal;
